import {ReactElement} from 'react';
import BadgeList from './BadgeList';
import PageImage from './PageImage';
import {IBadge} from '../type';

interface IProps {
  titleImg: string;
  title: string;
  badges: IBadge[];
  className?: string;
  titleImageClassName?: string;
  titleImageBottomElement?: ReactElement;
  badgeClassName?: string;
  onLoadTitleImage?: (isLoad: boolean) => void;
}

export default function ContentCardInfo({
  titleImg,
  title,
  badges,
  className,
  titleImageClassName,
  titleImageBottomElement,
  badgeClassName,
  onLoadTitleImage,
}: IProps) {
  return (
    <div
      className={cn(
        'w-full absolute left-0 bottom-10',
        'flex-center flex-col',
        className
      )}
    >
      <PageImage
        src={titleImg}
        className={cn(
          'w-full max-w-[115px] lg:max-w-[150px] mx-auto my-0',
          titleImageClassName
        )}
        alt={title}
        onLoad={onLoadTitleImage}
      />
      <BadgeList
        badges={badges}
        badgeClassName={badgeClassName}
        className="mt-6 px-2 flex-center gap-x-2"
      />
      {titleImageBottomElement}
    </div>
  );
}
